module.exports = __webpack_public_path__ + "static/media/logo.c5cb961a.png";